import React from 'react';
const CaptchaPlaceholder = () => <div>Captcha Placeholder</div>;
export default CaptchaPlaceholder;
